import relationshipClocks from "@/data/clocks/relationship-clocks.json";

function parseFrontmatter(raw) {
	const match = raw.match(/^---\n([\s\S]*?)\n---\n([\s\S]*)$/);
	if (!match) return { meta: {}, body: raw };

	const meta = {};
	match[1].split("\n").forEach(line => {
		const idx = line.indexOf(":");
		if (idx === -1) return;
		const key = line.slice(0, idx).trim();
		let val = line.slice(idx + 1).trim();
		if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
			val = val.slice(1, -1);
		}
		meta[key] = val;
	});

	return { meta, body: match[2].trim() };
}

function parseNpcMarkdown(raw) {
	const { meta, body } = parseFrontmatter(raw);

	const clock = relationshipClocks.find(c => c.npcId === meta.id) || {
		value: 5,
		mood: "Neutral",
		log: [],
	};
	const log = clock.log || [];
	const totalDelta = log.reduce((sum, entry) => sum + entry.delta, 0);
	const clockValue = Math.max(1, Math.min(10, clock.value + totalDelta));

	return {
		id: meta.id,
		name: meta.name,
		title: meta.title,
		pronouns: meta.pronouns,
		affiliation: meta.affiliation,
		shortName: meta.shortName || meta.name,
		portrait: meta.portrait,
		tags: meta.tags ? meta.tags.split(",").map(t => t.trim()) : [],
		met: meta.met === "true",
		// alive | deceased | unknown — anything else (or missing) counts as unknown
		status: ["alive", "deceased", "unknown"].includes((meta.status || "").toLowerCase())
			? meta.status.toLowerCase()
			: "unknown",
		clockValue,
		clockMood: clock.mood,
		log: clock.log || [],
		notes: body,
	};
}

const npcFiles = import.meta.glob("@/data/npcs/*.md", {
	query: "?raw",
	import: "default",
	eager: true,
});

export const npcs = Object.values(npcFiles)
	.map(raw => parseNpcMarkdown(raw))
	.filter(npc => npc.name);
